export default __webpack_public_path__ + "static/media/cont_item_06.eb29f92b.png";